function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
const BatchesIcon = forwardRef(function(_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    rest = _objectWithoutProperties(_ref, ['color', 'size']);

  return /*#__PURE__*/ React.createElement(
    'svg',
    _extends(
      {
        ref: ref,
        width: size,
        height: size,
        viewBox: '0 0 11 12',
        fill: color,
        xmlns: 'http://www.w3.org/2000/svg',
        stroke: 'none',
      },
      rest
    ),
    /*#__PURE__*/ React.createElement('path', {
      d:
        'M5.6882 7.2H3.16011C2.99249 7.2 2.83173 7.26321 2.7132 7.37574C2.59468 7.48826 2.52809 7.64087 2.52809 7.8C2.52809 7.95913 2.59468 8.11174 2.7132 8.22426C2.83173 8.33679 2.99249 8.4 3.16011 8.4H5.6882C5.85582 8.4 6.01658 8.33679 6.13511 8.22426C6.25364 8.11174 6.32022 7.95913 6.32022 7.8C6.32022 7.64087 6.25364 7.48826 6.13511 7.37574C6.01658 7.26321 5.85582 7.2 5.6882 7.2ZM8.21629 1.2H7.47051C7.34011 0.84987 7.09883 0.546599 6.77975 0.331763C6.46066 0.116927 6.07939 0.00104371 5.6882 0H4.42416C4.03297 0.00104371 3.6517 0.116927 3.33261 0.331763C3.01353 0.546599 2.77225 0.84987 2.64185 1.2H1.89607C1.3932 1.2 0.910927 1.38964 0.555345 1.72721C0.199764 2.06477 0 2.52261 0 3V10.2C0 10.6774 0.199764 11.1352 0.555345 11.4728C0.910927 11.8104 1.3932 12 1.89607 12H8.21629C8.71916 12 9.20143 11.8104 9.55701 11.4728C9.9126 11.1352 10.1124 10.6774 10.1124 10.2V3C10.1124 2.52261 9.9126 2.06477 9.55701 1.72721C9.20143 1.38964 8.71916 1.2 8.21629 1.2ZM3.79213 1.8C3.79213 1.64087 3.85872 1.48826 3.97725 1.37574C4.09578 1.26321 4.25653 1.2 4.42416 1.2H5.6882C5.85582 1.2 6.01658 1.26321 6.13511 1.37574C6.25364 1.48826 6.32022 1.64087 6.32022 1.8V2.4H3.79213V1.8ZM8.84831 10.2C8.84831 10.3591 8.78173 10.5117 8.6632 10.6243C8.54467 10.7368 8.38391 10.8 8.21629 10.8H1.89607C1.72844 10.8 1.56769 10.7368 1.44916 10.6243C1.33063 10.5117 1.26404 10.3591 1.26404 10.2V3C1.26404 2.84087 1.33063 2.68826 1.44916 2.57574C1.56769 2.46321 1.72844 2.4 1.89607 2.4H2.52809V3C2.52809 3.15913 2.59468 3.31174 2.7132 3.42426C2.83173 3.53679 2.99249 3.6 3.16011 3.6H6.95225C7.11987 3.6 7.28063 3.53679 7.39915 3.42426C7.51768 3.31174 7.58427 3.15913 7.58427 3V2.4H8.21629C8.38391 2.4 8.54467 2.46321 8.6632 2.57574C8.78173 2.68826 8.84831 2.84087 8.84831 3V10.2ZM6.95225 4.8H3.16011C2.99249 4.8 2.83173 4.86321 2.7132 4.97574C2.59468 5.08826 2.52809 5.24087 2.52809 5.4C2.52809 5.55913 2.59468 5.71174 2.7132 5.82426C2.83173 5.93679 2.99249 6 3.16011 6H6.95225C7.11987 6 7.28063 5.93679 7.39915 5.82426C7.51768 5.71174 7.58427 5.55913 7.58427 5.4C7.58427 5.24087 7.51768 5.08826 7.39915 4.97574C7.28063 4.86321 7.11987 4.8 6.95225 4.8Z',
    })
  );
});
BatchesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
BatchesIcon.displayName = 'BatchesIcon';
export default BatchesIcon;
